import { getOrdinalSuffix } from './dates/getOrdinalSuffix';

export function formatOrdinal(value: number) {
  return `${value}${getOrdinalSuffix(value)}`;
}
